import React from "react";
import { GlobalStateCtx } from "../../@types/seen-apps";

const GlobalStateContext = React.createContext<GlobalStateCtx>({} as GlobalStateCtx);

export const GlobalStateConsumer = GlobalStateContext.Consumer;
export default GlobalStateContext;
